<template>
  <div class='content-wrapper'>
    <Breadcrumb :title="$t('personalMenu-passwordSettings')" />
    <div class='content-body'>
      <div class='row'>
        <div class='col-xl-8 col-lg-8 col-md-12'>
          <section class='card'>
            <div class='card-content'>
              <div class='card-body p-3'>
                <PasswordForm />
              </div>
            </div>
          </section>
        </div>
        <Sidebar />
      </div>
    </div>
  </div>
</template>

<script>
import Sidebar from '@/components/personal/Sidebar.vue';
import PasswordForm from '@/components/personal/PasswordForm.vue';
import Breadcrumb from '@/components/layout/Breadcrumb';

export default {
  name: 'PasswordSettings',
  components: {
    Sidebar,
    PasswordForm,
    Breadcrumb
  }
};
</script>

<style scoped></style>
